import { APPEAR_ANIMATION_OPTIONS } from "@client/lib/jquery/animate";
import React from "react";
import SearchInput from "./Input/component";

import { AnimatedDiv } from "@client/content/hocs/animate";
import "./style.less";

export interface SearchMapProps {
  isVisible: boolean;
}

export interface SearchActionProps {
  close: () => void;
  onSearch: (text: string) => void;
}

export type SearchProps = SearchMapProps & SearchActionProps;

interface State {
  value: string;
}

class Search extends React.Component<SearchProps, State> {
  public state = {
    value: ""
  };

  public render() {
    const { close, isVisible } = this.props;
    if (!isVisible) return null;

    const { value } = this.state;
    return (
      <AnimatedDiv id="top-search" animationOptions={APPEAR_ANIMATION_OPTIONS}>
        <SearchInput close={close} onEnter={this._onEnter} onChange={this._onChange} value={value} />
        <a title="Clear search text" onClick={this._onClear} />
      </AnimatedDiv>
    );
  }

  private _onChange = (value: string) => this.setState({ value });

  private _onClear = () => this.setState({ value: "" });

  private _onEnter = (e: React.KeyboardEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.props.onSearch(this.state.value);
  };
}

export default Search;
